<div *ngIf="isVehicleScopingEnabled" class="vehicle-selection-scoping">
  <span class="vehicle-selection-scoping__label">
    <span i18n="@@S_GROUPS_SELECTED">GROUPS SELECTED</span>: {{ vehicleListScopingSelectedNodesCount }}/{{
      vehicleListScopingTotalNodesCount
    }}
  </span>
  <button
    mat-button
    id="btn-tree-selection-scoping-edit"
    class="btn-uppercase vzc-small"
    i18n="@@S_EDIT"
    (click)="onEditScopingClick(vehicleListScopingModalContent)"
  >
    EDIT
  </button>
</div>

<div class="vehicle-selection-mode-include-assets">
  <mat-form-field appearance="outline">
    <mat-label class="vehicle-selection-mode-include-assets__view" i18n="@@S_VIEW_VEHICLE_SELECTION_MODE">View</mat-label>

    <mat-select
      defaultText="Select an option"
      i18n-defaultText="@@S_SELECTANOPTION"
      panelClass="vehicle-driver-panel__dropdown-panel"
      disableOptionCentering="true"
      (selectionChange)="onSelectionModeChange($event.value)"
      (click)="$event.stopPropagation()"
      [value]="selectionMode"
    >
      <mat-option [value]="EVehicleSelectionMode.EntireFleet" i18n="@@S_ENTIRE_FLEET">Entire Fleet</mat-option>

      <mat-option [value]="EVehicleSelectionMode.Vehicles" i18n="@@S_VEHICLES">Vehicles</mat-option>

      <mat-option *ngIf="anyPoweredAssets" [value]="EVehicleSelectionMode.PoweredAssets" i18n="@@S_SEARCH_POWEREDASSET"
        >Powered assets</mat-option
      >

      <mat-option
        *ngIf="isAssetsEnabled && anyNonPoweredAssets"
        [value]="EVehicleSelectionMode.Assets"
        i18n="@@S_LIVE_MAP_NON_POWERED_ASSETS"
        >Non-powered assets</mat-option
      >

      <mat-option [value]="EVehicleSelectionMode.Drivers" i18n="@@S_DRIVERS">Drivers</mat-option>

      <mat-option [value]="EVehicleSelectionMode.Groups" i18n="@@S_GROUPS">Groups</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="vehicle-selection-tree">
  <fm-hierarchy-tree
    [maxSelectionMap]="maxSelectionMap"
    [treeData]="vehicleListTreeData"
    (nodeClick)="onHierarchyItemClick($event)"
    (nodeTextRightClick)="onVehicleRightClick($event)"
    (selectionChange)="onVehiclesSelectionChange($event)"
  ></fm-hierarchy-tree>
</div>
<div class="vehicle-selection-footer">
  <button
    mat-button
    class="btn-uppercase vzc-small"
    i18n="@@S_DESELECT_ALL"
    (click)="onDeselectAll()"
    a7s-id="vehicle-selection-panel-deselect-all"
  >
    DESELECT ALL
  </button>
</div>

<ng-template #vehicleListScopingModalContent>
  <fm-vehicle-list-scoping
    [treeData]="vehicleListScopingTreeData"
    (closeClick)="onVehicleListScopingClose()"
    (saveClick)="onVehicleListScopingSave($event)"
  ></fm-vehicle-list-scoping>
</ng-template>
